export default __webpack_public_path__ + "static/media/useState.aabb4675.md";